import React, { useState } from 'react';
import { observer } from 'mobx-react';
import MarkdownContent from './MarkdownContent';
import EditWrapper from './EditWrapper';
import GeneralAsks from '../../components/CompanyOverview/GeneralAsks';
import useUnsavedGuard from '../components/useUnsavedGuard';
import {
  PageWrapper, PageHeader, PageTitle, EditButton, Card, CardTitle,
  EmptyState, PageSkeleton,
} from './CompanyPage.styles';

const GeneralAsksPage = observer(({ company, mode }) => {
  const [editing, setEditing] = useState(false);
  const { onDirtyChange, confirmLeave } = useUnsavedGuard();
  const isReadonly = mode === 'readonly';
  const loaded = !!company?.id;
  const asks = company?.generalAsks || [];

  if (editing) {
    return (
      <PageWrapper>
        <PageHeader>
          <PageTitle>General Asks</PageTitle>
        </PageHeader>
        <EditWrapper onBack={() => { if (confirmLeave()) setEditing(false); }}>
          <GeneralAsks company={company} saveCallback={() => setEditing(false)} onDirtyChange={onDirtyChange} />
        </EditWrapper>
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <PageHeader>
        <PageTitle>General Asks</PageTitle>
        {loaded && !isReadonly && (
          <EditButton onClick={() => setEditing(true)}>
            {'✎'} Edit
          </EditButton>
        )}
      </PageHeader>

      {!loaded ? (
        <PageSkeleton>
          <div style={{ flex: 1, height: 240 }} />
        </PageSkeleton>
      ) : asks.length === 0 || (asks.length === 1 && !asks[0]?.trim()) ? (
        <EmptyState>No general asks have been added yet.</EmptyState>
      ) : (
        asks.filter(a => a?.trim()).map((ask, i) => (
          <Card key={i}>
            <CardTitle style={{ marginBottom: 12 }}>Ask #{i + 1}</CardTitle>
            <MarkdownContent markdown={ask} />
          </Card>
        ))
      )}
    </PageWrapper>
  );
});

export default GeneralAsksPage;
